import { Layout } from '@/components/Layout/Layout';
import { SavedFilterAlertArticles } from '@/features/saved-filter-alert/routes/SavedFilterAlertArticles';
import { Outlet, Route, Routes } from 'react-router-dom';

const AlertsLayout = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export const SavedFilterAlertRoutes = () => {
  return (
    <Routes>
      <Route element={<AlertsLayout />}>
        <Route
          path=":alertRunId/articles"
          element={<SavedFilterAlertArticles />}
        />
      </Route>
    </Routes>
  );
};
